import React, {Component} from 'react';
import {Link} from "react-router-dom";

class ListVpsUsCancelComponent extends Component {

    loadStatus = () => {
        if ( this.props.service.status_vps === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'progressing' || this.props.service.status_vps === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'rebuild' ) {
            return (
                <span className="text-info">
                    Đang cài đặt lại
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'reset_password' ) {
            return (
                <span className="text-info">
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_ip' ) {
            return (
                <span className="text-info">
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_vps === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                {
                                    this.props.service.ip ? (
                                        <>
                                            <Link to={'/dich-vu-vps-us/' + this.props.service.id + '/chi-tiet.html'}>{this.props.service.ip}</Link>
                                        </>

                                    ) : (
                                        <>IP: <span className="text-danger">Chưa tạo</span></>
                                    )
                                }
                                <br />
                                { this.props.service.state ? (
                                    <><b>{ this.props.service.state }</b></>
                                ) : (
                                    <>State: <span className="text-danger">Chưa tạo</span></>
                                )
                                }
                            </td>
                            <td>
                                {
                                    this.props.service.password ? (
                                        <>{ this.props.service.password }</>
                                    ) : (
                                        <span className="text-danger">Chưa tạo</span>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_config }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                {
                                    this.props.service.isExpire || this.props.service.expired ? (
                                        <>
                                            <span className="text-danger">{ this.props.service.text_next_due_date } </span>
                                            -
                                            <span className="text-danger"> { this.props.service.text_day }</span>
                                        </>
                                    ) : (
                                        <>
                                            { this.props.service.text_next_due_date } - { this.props.service.text_day }
                                        </>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }
}

export default ListVpsUsCancelComponent;